<div>
	<h2>{{'nav.defective_devices_page' | translate}}</h2>
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>
